module.exports = __webpack_public_path__ + "static/media/ziran.4f367ddb.png";